import { createFileRoute } from '@tanstack/react-router';
import { ProductsListScreen } from '../../../features/products/components/ProductsListScreen';

/** Products list (BUILD_SPEC.md §13 amendment, 2026-08-26 — Stuart's
 * front-and-centre ruling, nav.ts). No parent layout route: unlike the
 * screen-group sections (purchasing-intake, reports, ...), Products has no
 * persistent tab row to wrap this + $productId in. */
export const Route = createFileRoute('/_authenticated/products/')({
  component: ProductsListScreen,
});
